var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-text custom-hover-primary",on:{"click":_vm.openLanguageSelectionModal}},[_c('span',{staticClass:"icon"},[_c('i',[_c('b-icon',{staticClass:"is-clickable",attrs:{"icon":"globe"}})],1)]),_c('span',[_vm._v(_vm._s(_vm.$i18n.locale.split("-")[0].toUpperCase()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }